/**
 * Строка запроса в формате, который бэкенд получал от `qs.stringify(params, { arrayFormat: 'repeat' })`:
 * массив — повтором ключа, `null` — пустым значением (`a=`), `undefined` пропускается, вложенный объект —
 * ключом `a[b]`, дата — ISO. Стандартный сериализатор axios отличается: `null` выбрасывает, пробел пишет `+`.
 */
// Одиночный суррогат — U+FFFD, иначе encodeURIComponent бросает URIError; toWellFormed() нет в Firefox 114 из цели сборки.
const encode = (value: string) =>
    encodeURIComponent(value.replace(/\p{Cs}/gu, '\uFFFD')).replace(
        /[!'()*]/g,
        (char) => `%${char.charCodeAt(0).toString(16).toUpperCase()}`,
    );

const pairs = (key: string, value: unknown): string[] => {
    if (value === undefined) return [];
    if (value === null) return [`${encode(key)}=`];
    if (value instanceof Date) return [`${encode(key)}=${encode(value.toISOString())}`];
    if (Array.isArray(value)) return value.flatMap((item) => pairs(key, item));
    if (typeof value === 'object') {
        return Object.entries(value).flatMap(([name, item]) => pairs(`${key}[${name}]`, item));
    }
    return [`${encode(key)}=${encode(String(value))}`];
};

export const serializeParams = (params: Record<string, unknown>): string =>
    Object.entries(params)
        .flatMap(([key, value]) => pairs(key, value))
        .join('&');
